'use client';

import { useEffect, type ReactElement } from 'react';

const GTM_SCRIPT_BASE_URL = 'https://www.googletagmanager.com/gtm.js';
const SCROLL_RESTORATION_MANUAL = 'manual';

interface GoogleTagManagerWindow extends Window {
  dataLayer?: Record<string, unknown>[];
}

interface RootBrowserEffectsProps {
  gtmId: string;
  gtmScriptId: string;
}

export function RootBrowserEffects({
  gtmId,
  gtmScriptId,
}: RootBrowserEffectsProps): ReactElement | null {
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = SCROLL_RESTORATION_MANUAL;
    }

    if (document.getElementById(gtmScriptId)) {
      return;
    }

    const browserWindow = window as GoogleTagManagerWindow;
    const dataLayer = browserWindow.dataLayer ?? [];
    browserWindow.dataLayer = dataLayer;
    dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });

    const scriptUrl = new URL(GTM_SCRIPT_BASE_URL);
    scriptUrl.searchParams.set('id', gtmId);

    const script = document.createElement('script');
    script.id = gtmScriptId;
    script.async = true;
    script.src = scriptUrl.toString();
    document.head.appendChild(script);
  }, [gtmId, gtmScriptId]);

  return null;
}
